import { keyframes, styled } from 'styled-components';
import { ScButtonHeart } from '@/components/buttons/styled';
import type { TCardMode } from '@/modules/game/types';
import { device, typography } from '@/styles/helpers';
import { ScPlayButton } from '../../PlayButton/styled';

/* stop propagation click on mobile devices */
export const enablePointerEvents = keyframes`
  to {
    pointer-events: auto;
  }
`;

export const ScGameCardFront = styled.div`
  & .tournament-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    position: absolute;
    height: 20px;
    width: 100%;
    bottom: 0;
    border-radius: 0px 0px 11px 11px;
    background: rgba(25, 25, 25, 0.8);
    backdrop-filter: blur(5px);

    @container game-card (min-width: 141px) {
      height: 24px;
    }

    & span {
      font-size: 10px;
      line-height: 14px;
      letter-spacing: 0px;
      font-weight: 700;
      color: ${({ theme }) => theme.whiteColor};

      @container game-card (min-width: 141px) {
        font-size: 12px;
        line-height: 18px;
      }
    }

    & .tournament-image {
      width: 14px;
      height: 14px;
    }
  }
`;

export const ScGameCardBack = styled.div`
  position: relative;
  display: none;
  width: 100%;
  height: 100%;
  padding: 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  & .demo-link {
    ${typography['caption1bold']};
    letter-spacing: 0px;
    position: absolute;
    bottom: 12px;
    color: ${({ theme }) => theme.secondaryColor};
    text-decoration: underline;
    transition: color 0.2s ease-in-out;
    @container game-card (max-width: 117px) {
      bottom: 2px;
    }

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.secondaryColorHover};
      }
    }
  }

  @container game-card (max-width: 117px) {
    ${ScButtonHeart} {
      width: 20px;
      height: 20px;
    }
  }

  @container game-card (max-width: 90px) {
    ${ScPlayButton} {
      width: 48px;
      height: 48px;
    }
    ${ScButtonHeart}, .demo-link {
      display: none;
    }
  }
`;

interface IScGameCardInnerProps {
  mode: TCardMode;
}

export const ScGameCardInner = styled.div<IScGameCardInnerProps>`
  container-type: inline-size;
  container-name: game-card;
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: ${({ mode }) =>
    mode === 'light'
      ? 'linear-gradient(270deg, #F2F2F4 0%, #D3D3D9 100%)'
      : 'linear-gradient(90deg, #131314 0%, #1c1c1e 100%)'};
  border-radius: 12px;

  ${ScGameCardBack} {
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
  }

  & .cover-image {
    border-radius: 12px;
  }

  & .heart-image {
    position: absolute;
    top: -4px;
    right: -4px;
  }

  &:hover {
    & ${ScGameCardFront} {
      display: none;
    }

    & ${ScGameCardBack} {
      display: flex;
    }

    @media (${device.mobile}) {
      ${ScPlayButton}, .demo-link {
        pointer-events: none;
        animation: ${enablePointerEvents} 0.5s forwards 0.5s;
      }
    }
  }
`;
